import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Post from "../../../Apis/backlink/Post";
import { getAPIUrlBM } from "../../../utils/config";
import { SelectionBar } from "../ManageTeam/ManageTeam";
import { getWorkSpaceData } from "../../../store/actions/userData/WorkspaceData";

const AcceptInvite = () => {
  const routesData = useParams();
  const Navigation = useNavigate();
  const [userData, setUserData] = useState({});
  const { workspaceId } = routesData;
  const host = getAPIUrlBM();
  const dispatch = useDispatch();
  useEffect(() => {
    const getUserData = async () => {
      try{
        const response = await Post(host + "/fetchTeam", {
          workspaceId,
        });
        if (!response.data) {
          toast.dismiss();
          toast.info(response?.message);
        }
        if (response.data.Active) {
          Navigation("backlink/link");
          return toast.info("You've alredy accepted the request.");
        }
        setUserData(response.data);
      } catch (error) {
        console.log(error)
      }
    };
    getUserData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handler = async () => {
    try {
      const response = await Post(host + "/acceptteam", {
        workspaceId,
      });
      // console.log(response, "Response coming");
      if (!response.active) {
        toast.dismiss();
        return toast.info(response.message);
      }
      toast.success(response.message);
      dispatch(getWorkSpaceData("backlink"));

      Navigation("/backlink/link");
    } catch (err) {}
  };
  return (
    <div>
      <div
        style={{
          padding: "1rem",
        }}
      >
        <div>Ahoy!</div>
        <span>You have been invited to {userData?.name}'s workspace</span>
      </div>

      <div
        style={{
          padding: "1rem 2rem",
        }}
      >
        <div>Access given to </div>
        <div
          style={{
            marginTop: "1rem",
            display: "flex",
            gap: "4rem",
            minWidth: "800px",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "45%",
            }}
          >
            <SelectionBar permanent={true} data={userData?.roles ?? []} />
          </div>
          <div
            style={{
              width: "55%",
            }}
          >
            <span
              style={{
                backgroundColor: "#5541D7",
                color: "#fff",
                padding: "0.8rem 1.2rem",
                fontWeight: "600",
                borderRadius: "10px",
                cursor: "pointer",
              }}
              onClick={handler}
            >
              Accept Invite
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcceptInvite;
